// Componente per la gestione Toolbar
import React from 'react';
import PropTypes from 'prop-types';
import {get} from './Storage';
import IconButton from 'material-ui/IconButton';
import DepositToolsPage from './Page/DepositTools';
import { MGBadge } from "mgUiKit";
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'ToolbarCompactComponent';
var styles = AppSettings.styles;

class ToolbarCompact extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTab = this.handleTab.bind(this);
        this.switchToolbar = this.switchToolbar.bind(this);
        this.handleToggleBalance = this.handleToggleBalance.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleTab(tab, event) {
        this.props.handleTab(tab);
    }

    switchToolbar(mode) {
        this.props.switchToolbar(mode);
    }

    handleToggleBalance() {
        if (this.state.showBalance) {
            this.setState({
                showBalance: false
            });
        }
        else {
            this.setState({
                showBalance: true
            });
        }
    }

    handleClose(){
        window.location.href = AppSettings.urlLogout;
    }
    
    render() {
        return (
            <div className="user-box-toolbar user-box-toolbar-compact">
                <ul id="user-box-toolbar-list">
                    <li onClick={this.switchToolbar.bind(this,'full')} id="user-box-close">
                        <IconButton iconClassName="fa fa-expand"
                                    iconStyle={styles.topIconStyle} />
                    </li>

                    {AppSettings["perms"].tabProfile?
                    <li onClick={this.handleTab.bind(this,"profile")} id="user-box-profilo">
                         <i className="fa-mg fa-mg-user-2"></i>
                    </li>
                    : null }

                    {AppSettings['perms'].deposit && AppSettings.showdepositbuttonintoolbar?
                            <li id="user-box-deposit">
                                <DepositToolsPage  typeButton="icon"/>
                            </li>

                        : null}

                    {AppSettings["perms"].tabCoupon?
                    <li onClick={this.handleTab.bind(this,"coupon")} id="user-box-bonus">
                        {/* {this.props.countCoupon > 0 ?
                            <Badge badgeContent={this.props.countCoupon}
                                secondary={true}
                                style={styles.badgeNotifications}
                                badgeStyle={styles.badgeStyle}

                            >
                                <IconButton iconClassName="fa-mg fa-mg-promo-2"
                                            iconStyle={styles.topIconStyle} />
                            </Badge>
                            :
                            <IconButton iconClassName="fa-mg fa-mg-promo-2"
                                        iconStyle={styles.topIconStyle} />

                        } */}
                           <i className="fa-mg fa-mg-promo-2"></i>
                                {this.props.countCoupon > 0 ?
                                        <MGBadge badgeContent={this.props.countCoupon}/>                                 
                                    : null 
                            }
                    </li>
                    : null}
                     {AppSettings["perms"].tabNews?
                    <li onClick={this.handleTab.bind(this,"news")} id="user-box-messaggi">
                        <i className="fa-mg fa-mg-mail-1"></i>
                            {this.props.countNews > 0 ?
                                    <MGBadge badgeContent={this.props.countNews}/>                                 
                                : null 
                            }
                        {/* {this.props.countNews > 0 ?
                            <Badge badgeContent={this.props.countNews}
                                   secondary={true}
                                   style={styles.badgeNotifications}
                                   badgeStyle={styles.badgeStyle}>
                                <IconButton iconClassName="fa-mg fa-mg-mail-1"
                                            iconStyle={styles.topIconStyle} />
                            </Badge>
                            :
                            <IconButton iconClassName="fa-mg fa-mg-mail-1"
                                        iconStyle={styles.topIconStyle} />

                        } */}
                    </li>
                    : null }

                    {/*AppSettings["perms"].tabControlPanel?
                    <li onClick={this.handleTab.bind(this,"panel")} id="user-box-pannello">
                        <IconButton iconClassName="fa fa-th"
                                    iconStyle={styles.topIconStyle}
                        />
                    </li>
                    : null*/ }

                        <li id="user-box-logout" onClick={this.handleClose.bind(this)}>
                            <i className="fa-mg fa-mg-log-off"></i>
                        </li>  
                    {/* <li id="user-box-logout">
                        <IconButton href={AppSettings.urlLogout}
                                    iconClassName="fa-mg fa-mg-log-off"
                                    iconStyle={styles.topIconStyle}
                        />
                    </li> */}
                </ul>
            </div>
        )
    }
}

ToolbarCompact.displayName = componentName;

// PropTypes validation
ToolbarCompact.propTypes = {
    switchToolbar: PropTypes.func,
    countNews: PropTypes.number,
    countCoupon: PropTypes.number,
    countMission: PropTypes.number
};

// default props
ToolbarCompact.defaultProps = {
    switchToolbar: function () {
    }
};

export default  ToolbarCompact;